import { Controller } from "@hotwired/stimulus"

// Fills a target field with the text from a clicked example chip, then focuses
// it so the user can edit before submitting. Used on the New Agent intake form
// to give people a head start without cluttering the page.
//
// Usage:
//   <div data-controller="example-prompt">
//     <textarea data-example-prompt-target="field"></textarea>
//     <button data-action="example-prompt#fill"
//             data-example-prompt-text-param="Sort each incoming email...">
//       Sort incoming messages
//     </button>
//   </div>
export default class extends Controller {
  static targets = ["field"]

  fill(event) {
    if (!this.hasFieldTarget) return
    const text = event.params.text
    if (!text) return

    this.fieldTarget.value = text
    this.fieldTarget.focus()
    // Put the cursor at the end so editing feels natural.
    const len = this.fieldTarget.value.length
    this.fieldTarget.setSelectionRange(len, len)
  }
}
